import React, { FC, LegacyRef } from "react";
import { FlexBox } from "components/flex-box";
import RowTotal from "./RowTotal";
import { componentRows } from "modules/pcbuilder/constants";
import modules from "modules";
import { useAppSelector } from "hooks/use-app-selector";
import { mapComponentNameToCategoryName } from "modules/pcbuilder";
import { ScreenshotRowLabel } from "./ScreenshotRowLabel";
import { ScreenshotRow } from "./ScreenshotRow";

const { selectors: pcBuilderSelectors } = modules.pcBuilder;

interface Props {
  screenshotRef: LegacyRef<HTMLDivElement>;
}

export const ScreenshotComponent: FC<Props> = ({ screenshotRef }) => {
  const buildParts = useAppSelector(pcBuilderSelectors.selectBuildParts);
  const filteredRows =
    componentRows.filter((c) => {
      const name = mapComponentNameToCategoryName(c.name);
      const categories = buildParts.map((b) => b.category_name);
      return categories.includes(name);
    }) ?? [];

  return (
    <div
      ref={screenshotRef}
      // intended style to hide component from view
      style={{
        position: "fixed",
        top: "-9999px",
        left: "-9999px",
        pointerEvents: "none",
        zIndex: -9999,
        width: "1454px", // intended fix width for uniform image and layout size
      }}
    >
      <FlexBox flexDirection="column" bgcolor="white">
        <>
          <RowTotal isScreenshot={true} />
          <ScreenshotRowLabel />
          {filteredRows?.map((part, i) => (
            <ScreenshotRow data={part} key={`${part?.name}${i}`} />
          ))}
          <RowTotal isScreenshot={true} />
        </>
      </FlexBox>
    </div>
  );
};
